import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { Anwendung, AnwendungEvent } from '../../documents/behandlungsanfrage/anwendung';
import { KieneTableService } from '../kiene-table/kiene-table.service';

@Component({
    selector: 'kiene-anwendungs-selector',
    templateUrl: './anwendungs-selector.component.html',
    styleUrls: ['./anwendungs-selector.component.css'],
})
export class AnwendungsSelectorComponent implements OnInit, OnChanges {
    @ViewChild('anwendungSelect') anwendungSelect: MatSelect;

    anwendungCtrl = new UntypedFormControl();
    anwendungen: Anwendung[] = [];

    @Input('disabled') disabled = false;
    @Input('kundeMandantId') kundeMandantId: number;
    @Input('required') required = false;
    @Output('change') change = new EventEmitter<AnwendungEvent>();

    constructor(
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        if (this.required) {
            this.anwendungCtrl.setValidators([Validators.required]);
        }
        this.syncDisabledState();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['disabled']) {
            this.syncDisabledState();
        }
    }

    private syncDisabledState(): void {
        if (this.disabled) {
            this.anwendungCtrl.disable({ emitEvent: false });
        } else {
            this.anwendungCtrl.enable({ emitEvent: false });
        }
    }

    public isValid(): boolean {
        if (!this.required) {
            return true;
        } else {
            return this.anwendungCtrl.valid;
        }
    }

    loadAnwendungen(materialId: number, tierartId: number, emit: boolean, ladePosition: boolean) {
        if (!materialId || !tierartId) {
            return;
        }

        let params = new HttpParams();
        params = params.set('artikel_id', materialId.toString());
        params = params.set('tierart_id', tierartId.toString());

        let headers;
        if (this.kundeMandantId !== undefined) {
            headers = { 'MANDANTID-KUNDE': this.kundeMandantId.toString() };
        }

        this.api.get(this.apiBaseUrl + 'anwendung/read_beleg.php', params, headers).subscribe(
            response => {
                this.anwendungen = response.records;
                if (this.anwendungen.length === 1) {
                    this.anwendungCtrl.setValue(this.anwendungen[0]);
                    if (ladePosition) {
                        this.change.emit(new AnwendungEvent(this.anwendungen[0], { ladePosition: true }));
                    } else if (emit) {
                        this.change.emit(new AnwendungEvent(this.anwendungen[0]));
                    }
                } else {
                    if (emit && !ladePosition) {
                        this.setFocus();
                    }
                }
            },
            () => {},
        );
    }

    anwendungSelected(event: MatSelectChange) {
        this.change.emit(new AnwendungEvent(event.value));
    }

    anwendungOpenedChange() {}

    anwendungComparator(a: Anwendung, b: Anwendung) {
        if (a && b) {
            return Number(a.anwendung_id) === Number(b.anwendung_id);
        }
        return false;
    }

    public clear() {
        this.anwendungen = [];
        this.anwendungCtrl.setValue(null);
        this.anwendungSelect.close();
        this.anwendungCtrl.markAsUntouched();
        this.change.emit(new AnwendungEvent(null));
    }

    public close() {
        this.anwendungSelect.close();
    }

    public setFocus(): void {
        console.debug('AnwendungsSelector setFocus() at %s', new Date().toISOString());
        setTimeout(() => {
            this.anwendungSelect?.focus();
            this.openPanel();
        }, 50);
    }

    public openPanel() {
        this.anwendungSelect.open();
    }

    public setAnwendung(anwendung: Anwendung, tierartId: number, emit: boolean, ladePosition: boolean) {
        this.anwendungCtrl.setValue(anwendung, { emitEvent: emit });
        this.loadAnwendungen(anwendung.artikel_id, tierartId, emit, ladePosition);
    }

    public getAnwendung(): Anwendung {
        return this.anwendungCtrl?.value;
    }
}
